import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { serializer } from './serializer';
import { getStore } from '@core/store';

bus.on(constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH, () => {
  const requestId = `listAllTransactions-${Date.now()}`;

  const userStore = getStore('user');
  let url = `${constants.ENDPOINTS.TRANSACTIONS.GET_LIST}`;
  url = url.replace('{userId}', userStore.state.current.id);

  bus.emit(EVENTS.TRANSACTIONS.LIST_ALL.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'GET',
    data: {}
  });

  const handler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(EVENTS.TRANSACTIONS.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.TRANSACTIONS.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});

bus.on(constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, (data) => {
  setTimeout(() => {
    bus.emit(EVENTS.TRANSACTIONS.DETAIL.REFRESHED, data);
  }, 500);
  return;

  const requestId = `transactionDetail-${Date.now()}`;
  bus.emit(EVENTS.TRANSACTIONS.DETAIL.REFRESHING);
  const url = `${constants.ENDPOINTS.TRANSACTIONS.GET_DETAIL}`.replace(
    /{id}/,
    data?.id
  );
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: url,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      // bus.off(constants.EVENTS.NETWORK.RESPONSE);
      const parsed = serializer.deserializeTransactoinDetail(res);
      if (parsed.success) {
        bus.emit(EVENTS.TRANSACTIONS.DETAIL.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.TRANSACTIONS.DETAIL.REFRESH_ERROR, parsed);
      }
    }
  });
});
